import {registerPermissionGrantedCallback} from "@elements/cookie-permissions";
export function init () {
    registerPermissionGrantedCallback('accessiWay', function () {
        (function(){
            var s = document.createElement('script'),
                e = !document.body ? document.querySelector('head') :
                    document.body;
            s.src = 'https://eu.acsbapp.com/apps/app/dist/js/app.js';
            s.async = true;
            s.onload = function(){
                acsbJS.init({
                    statementLink : '',
                    footerHtml :  '<a  href="https://www.accessiway.com/" target="_blank">AccessiWay. The Web Accessibility Solution</a>',
                    hideMobile : false,
                    hideTrigger : false,
                    language : 'de',
                    position : 'left',
                    leadColor : '#d34442',
                    triggerColor : '#d34442',
                    triggerRadius : '3.3125rem',
                    triggerPositionX : 'left',
                    triggerPositionY : 'bottom',
                    triggerIcon : 'people',
                    triggerSize : 'medium',
                    triggerOffsetX : 10,
                    triggerOffsetY : 10,
                    mobile : {
                        triggerSize : 'medium',
                        triggerPositionX : 'left',
                        triggerPositionY : 'bottom',
                        triggerOffsetX : 0,
                        triggerOffsetY : 0,
                        triggerRadius : '3.3125rem'
                    }
                });
            };
            e.appendChild(s);
        }());
    })
}